import {validate as emailValidate} from 'email-validator';

export const funcValidateIdentifier = (
    value: string,
    transactionDate: string | undefined,
    amount: string,
    currencyCode: { label: string; value: string },
    paymentMethod: { label: string; value: string },
    email: string
) => {
    if ((!transactionDate && !amount && !currencyCode && !paymentMethod && !email) && (!value)) {
        return 'formData.validation.required';
    }
}

export const funcValidateDate = (
    value: string | undefined,
    identifier: string,
    amount: string,
    currencyCode: { label: string; value: string },
    paymentMethod: { label: string; value: string },
    email: string
) => {
    if (identifier) {
        return true
    }
    if ((amount || paymentMethod || email || currencyCode) && !value) {

        return 'formData.validation.required';
    }

    if (value && !isNaN(Date.parse(value))) {
        const givenDate = new Date(value);
        const currentDate = new Date();

        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(currentDate.getMonth() - 3);

        const tomorrow = new Date();
        tomorrow.setDate(currentDate.getDate());
        tomorrow.setHours(0, 0, 0, 0);
        return givenDate > threeMonthsAgo && givenDate < tomorrow ? true : 'formData.validation.date.incorrect';
    }
}

export const funcValidateAmount = (
    value: string,
    identifier: string,
    email: string,
    currencyCode: { label: string; value: string },
    paymentMethod: { label: string; value: string },
    transactionDate: string | undefined
) => {
    if (identifier) {
        return true
    }
    if (email || currencyCode || paymentMethod || transactionDate) {
        if (!value) {
            return 'formData.validation.required';
        }
    }
    return true;
}

export const funcValidateCurrency = (
    value: { label: string; value: string },
    identifier: string,
    transactionDate: string | undefined,
    amount: string,
    paymentMethod: { label: string; value: string },
    email: string
) => {
    if (identifier) {
        return true
    }
    if (amount || paymentMethod || email || transactionDate) {
        return !!value || 'formData.validation.required';
    }
    return true;
}

export const funcValidatePaymentMethod= (
    value: { label: string; value: string },
    identifier: string,
    amount: string,
    currencyCode: { label: string; value: string },
    email: string,
    transactionDate: string | undefined
) => {
    if (identifier) {
        return true
    }
    if (amount || currencyCode || email || transactionDate) {
        return !!value || 'formData.validation.required';
    }
    return true;
}

export const funcValidateEmail= (
    value: string,
    identifier: string,
    amount: string,
    currencyCode: { label: string; value: string },
    paymentMethod: { label: string; value: string },
    transactionDate: string | undefined
) => {
    if (identifier) {
        return true
    }
    if (amount || currencyCode || paymentMethod || transactionDate || value) {
        if (!value) {
            return 'formData.validation.required';
        }
        return emailValidate(value) ? true : 'formData.validation.incorrectEmail';
    }
    return true;
}


